import MediaGridSelectionItem from "./media-grid-selection-item";
import * as styles from "./media-grid-selection.css";

type Media = {
  id: string;
  preview: string;
  type: "video" | "image";
  private?: boolean;
  isScheduled?: boolean;
  duration?: number;
  price?: {
    value: number;
    currency: string;
  };
  imageCount?: number;
  videoCount?: number;
  status?: "Ready" | "Pending" | "Error";
};

export interface MediaGridSelectionProps<T> {
  medias?: T[];
  onSelectItem?: (media?: T) => void;
  selectedMedias?: T[];
  maxItems?: number;
  uploadingMediaIds?: string[];
}

export default function MediaGridSelection<T extends Media>({
  medias,
  onSelectItem,
  selectedMedias,
  maxItems,
  uploadingMediaIds = [],
  ...props
}: MediaGridSelectionProps<T>) {
  return (
    <div className={styles.panel} data-testid="media-grid-panel" {...props}>
      {medias?.map((media: Media) => (
        <MediaGridSelectionItem
          data-testid="media-grid-selection-item"
          media={media}
          key={media.id}
          disabled={
            maxItems
              ? selectedMedias &&
                selectedMedias.length >= maxItems &&
                !selectedMedias?.some(
                  (selectedMedia) => selectedMedia.id === media.id
                )
              : false
          }
          checked={!!selectedMedias?.find((medium) => medium.id === media.id)}
          isLoading={uploadingMediaIds.includes(media.id)}
          onSelectItem={(mediaId: string) => {
            onSelectItem?.(medias.find((media: Media) => media.id === mediaId));
          }}
        />
      ))}
    </div>
  );
}
